
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import { filter, includes } from 'lodash';

import SelectOption from './SelectOption';

import './selectOptionsGroup.scss';

export function SelectOptionsGroup({
	options: optionsProp,
	groupType = 'single',
	name,
	selected: selectedProp,
	onChange,
}) {
	const [selected, setSelected] = useState(() => {
		if (!isNil(selectedProp)) {
			return selectedProp;
		}
		return groupType === 'single' ? null : [];
	});

	const handleSelect = (checked, value) => {
		let newSelected;
		if (groupType === 'single') {
			newSelected = value;
		} else if (checked) {
			newSelected = [...selected, value];
		} else {
			newSelected = filter(selected, (v) => v !== value);
		}
		onChange(newSelected);
		setSelected(newSelected);
	};

	const handleChange = (event) => {
		const { checked, value } = event.target;
		handleSelect(checked, value);
	};

	const options = optionsProp.map((option) => {
		let optionSelected;
		if (groupType === 'single') {
			optionSelected = selected === option.value;
		} else {
			optionSelected = includes(selected, option.value);
		}
		return {
			...option,
			selected: optionSelected,
			id: `${name}-${option.value}`,
		};
	});

	return (
		<div className="select-options-group">
			{options.map((option) => (
				<SelectOption
					name={name}
					key={option.id}
					display={option.display}
					className="option-group-input"
					value={option.value}
					checked={option.selected}
					onChange={handleChange}
					disabled={option.disabled}
					id={option.id}
					type={groupType === 'single' ? 'radio' : 'checkbox'}
				/>
			))}
		</div>
	);
}

SelectOptionsGroup.propTypes = {
	/** Options to display */
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			display: PropTypes.any,
			disabled: PropTypes.bool,
		}),
	).isRequired,
	/** The name of the set of options */
	name: PropTypes.string.isRequired,
	/** The type of group, either single select of multi select */
	groupType: PropTypes.oneOf(['single', 'multiple']),
	/** The currently selected value(s) */
	selected: PropTypes.any,
	/** Change handler */
	onChange: PropTypes.func,
};

export default SelectOptionsGroup;
